import React, { useEffect, useRef, useContext } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { ContextBoard } from "../context/ContextBoard";

const PrivateRoute = ({ children, tokenKey = "tokenclassix" }) => {
  const {
    setCandidateid,
    setMode,
    setDivyangcode,
    setCastecode,
    setClass9exregulardata,
    setRegistrationNumber,
    setSessionCode,
  } = useContext(ContextBoard);
  const location = useLocation();
  const navigate = useNavigate();
  const token = sessionStorage.getItem(tokenKey);
  const prevPath = useRef(location.pathname + location.search);

  useEffect(() => {
    const currentPath = location.pathname;
    const currentSearch = new URLSearchParams(location.search);
    const currentMode = currentSearch.get("mode");

    const prevURL = new URLSearchParams(prevPath.current.split("?")[1]);
    const prevPathname = prevPath.current.split("?")[0];
    const prevMode = prevURL.get("mode");

    // ✅ Case 1: Leaving regular-student/upload-document → clear all context
    if (
      (prevPathname === "/class-ix-regular-student" ||
        prevPathname === "/class-ix-upload-document") &&
      !(
        currentPath === "/class-ix-regular-student" ||
        currentPath === "/class-ix-upload-document"
      )
    ) {
      setCandidateid("");
      setDivyangcode("");
      setCastecode("");
      setMode("");
      setRegistrationNumber("");
      setSessionCode("");
      setClass9exregulardata("");
    }
    if (
      (prevPathname === "/class-ix-add-ex-regular-student" ||
        prevPathname === "/class-ix-upload-document") &&
      !(
        currentPath === "/class-ix-add-ex-regular-student" ||
        currentPath === "/class-ix-upload-document"
      )
    ) {
      setCandidateid("");
      setDivyangcode("");
      setCastecode("");
      setMode("");
      setRegistrationNumber("");
      setSessionCode("");
      setClass9exregulardata("");
    }

    // ✅ Case 2: Special case → upload-document → regular-student/add-ex-regular-student
    if (
      prevPathname === "/class-ix-upload-document" &&
      (currentPath === "/class-ix-regular-student" ||
        currentPath === "/class-ix-add-ex-regular-student" ||
        currentPath === "/class-ix-correct-student" ||
        currentPath === "/class-ix-correct-ex-student")
    ) {
      setCandidateid("");
      setDivyangcode("");
      setCastecode("");
      setMode("");
      setRegistrationNumber("");
      setSessionCode("");
      setClass9exregulardata("");
      navigate("/class-ix-total-registration");
    }

    prevPath.current = location.pathname + location.search;
  }, [location]);

  if (token) {
    const currentPath = location.pathname;

    if (
      sessionStorage.getItem("class9profile") === "NO" &&
      currentPath !== "/class-ix-school-profile"
    ) {
      return <Navigate to="/class-ix-school-profile" />;
    }
  } else {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default PrivateRoute;
